export default __webpack_public_path__ + "static/media/feedingthepyre.3fb886c8.png";